import React, { Component } from "react";
import { RouteData } from "react-static";

import Loader from "components/loader/loader";

import ProjectContent from "./project/projectContent/projectContentContainer";
import NextProjectNavigator from "./project/projectNavigator/nextProjectNavigator/nextProjectNavigator";
import PreviousProjectNavigator from "./project/projectNavigator/previousProjectNavigator/previousProjectNavigator";

export default class Project extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false
    };

    this.handleRouteLoad = this.handleRouteLoad.bind(this);
  }

  handleRouteLoad(loaded, callback) {
    this.setState(
      {
        loaded
      },
      callback
    );
  }

  render() {
    return (
      <RouteData>
        {({ currentProject, previousProject, nextProject }) => {
          //
          if (
            currentProject.fields.passwordProtected === true &&
            this.state.loaded === false
          ) {
            this.setState({ loaded: true });
          }
          return (
            <div>
              <Loader loaded={this.state.loaded} />
              <ProjectContent
                project={currentProject}
                handleRouteLoad={this.handleRouteLoad}
                loaded={this.state.loaded}
              />
              <PreviousProjectNavigator
                project={previousProject}
                handleRouteLoad={this.handleRouteLoad}
              />
              <NextProjectNavigator
                project={nextProject}
                handleRouteLoad={this.handleRouteLoad}
              />
            </div>
          );
        }}
      </RouteData>
    );
  }
}
